module.exports = __webpack_public_path__ + "static/media/fpl_pts.81dc8bb3.png";